// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SeasonRewardsInformationStage__root--TZMv_ {
    text-align: left;
}

.SeasonRewardsInformationStage__prizes--F13Wp {
    width: 100%;
    position: relative;
}

@media screen and (min-width: 1024px) {

.SeasonRewardsInformationStage__prizes--F13Wp {
        height: 412px
}
    }

.SeasonRewardsInformationStage__prizeItem--wvie_ {
    display: grid;
    grid-template-columns: 112px auto;
    grid-gap: 16px;
}

@media screen and (min-width: 1024px) {

.SeasonRewardsInformationStage__prizeItem--wvie_ {
        grid-template-columns: 172px auto;
        align-items: center;
        width: 414px
}

        .SeasonRewardsInformationStage__prizeItem--wvie_:nth-child(2) {
            position: absolute;
            top: 120px;
            left: 113px;
        }

        .SeasonRewardsInformationStage__prizeItem--wvie_:last-child {
            position: absolute;
            bottom: 0;
            left: 226px;
        }
    }

.SeasonRewardsInformationStage__prizeItemImages--OIPQo {
    width: 100%;
    height: 100%;
    position: relative;
}

.SeasonRewardsInformationStage__skinImage--H7vAW {
    width: 100%;
    height: auto;
    aspect-ratio: 1;
}

.SeasonRewardsInformationStage__placeImage--ltWGi {
    width: 32px;
    height: 32px;
    position: absolute;
    left: 0;
    top: 0;
}

@media screen and (min-width: 1024px) {

.SeasonRewardsInformationStage__placeImage--ltWGi {
        top: 56px
}
    }

.SeasonRewardsInformationStage__label--STzRD {
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    margin-bottom: 8px;
}

.SeasonRewardsInformationStage__skinName--UmXCB {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: var(--tertiary-color);
}

@media screen and (min-width: 1024px) {

.SeasonRewardsInformationStage__skinName--UmXCB {
        font-size: 16px
}
    }
`, "",{"version":3,"sources":["webpack://./src/components/SeasonRewardsInformationStage/SeasonRewardsInformationStage.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;AAKtB;;AAHI;;AAJJ;QAKQ;AAER;IADI;;AAGJ;IACI,aAAa;IACb,iCAAiC;IACjC,cAAc;AAmBlB;;AAjBI;;AALJ;QAMQ,iCAAiC;QACjC,mBAAmB;QACnB;AAcR;;QAZQ;YACI,kBAAkB;YAClB,UAAU;YACV,WAAW;QACf;;QAEA;YACI,kBAAkB;YAClB,SAAS;YACT,WAAW;QACf;IACJ;;AAGJ;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,MAAM;AAKV;;AAHI;;AAPJ;QAQQ;AAER;IADI;;AAGJ;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;AAKhC;;AAHI;;AANJ;QAOQ;AAER;IADI","sourcesContent":[".root {\n    text-align: left;\n}\n\n.prizes {\n    width: 100%;\n    position: relative;\n\n    @media (--large) {\n        height: 412px;\n    }\n}\n\n.prizeItem {\n    display: grid;\n    grid-template-columns: 112px auto;\n    grid-gap: 16px;\n\n    @media (--large) {\n        grid-template-columns: 172px auto;\n        align-items: center;\n        width: 414px;\n\n        &:nth-child(2) {\n            position: absolute;\n            top: 120px;\n            left: 113px;\n        }\n\n        &:last-child {\n            position: absolute;\n            bottom: 0;\n            left: 226px;\n        }\n    }\n}\n\n.prizeItemImages {\n    width: 100%;\n    height: 100%;\n    position: relative;\n}\n\n.skinImage {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 1;\n}\n\n.placeImage {\n    width: 32px;\n    height: 32px;\n    position: absolute;\n    left: 0;\n    top: 0;\n\n    @media (--large) {\n        top: 56px;\n    }\n}\n\n.label {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 20px;\n    letter-spacing: 0.6px;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n}\n\n.skinName {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px;\n    color: var(--tertiary-color);\n\n    @media (--large) {\n        font-size: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SeasonRewardsInformationStage__root--TZMv_`,
	"prizes": `SeasonRewardsInformationStage__prizes--F13Wp`,
	"prizeItem": `SeasonRewardsInformationStage__prizeItem--wvie_`,
	"prizeItemImages": `SeasonRewardsInformationStage__prizeItemImages--OIPQo`,
	"skinImage": `SeasonRewardsInformationStage__skinImage--H7vAW`,
	"placeImage": `SeasonRewardsInformationStage__placeImage--ltWGi`,
	"label": `SeasonRewardsInformationStage__label--STzRD`,
	"skinName": `SeasonRewardsInformationStage__skinName--UmXCB`
};
export default ___CSS_LOADER_EXPORT___;
